
import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface CTASectionProps {
  email: string;
  setEmail: (email: string) => void;
  handleSubscribe: (e: React.FormEvent) => Promise<void>;
  isSubmitting: boolean;
  subscribed: boolean;
}

export const CTASection = ({
  email,
  setEmail,
  handleSubscribe,
  isSubmitting,
  subscribed
}: CTASectionProps) => {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-4">Ready to transform your podcast workflow?</h2>
          <p className="text-xl text-muted-foreground mb-8">
            Join the waiting list to be among the first to experience Agent V
          </p>
          
          {!subscribed ? (
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto">
              <div className="flex-grow">
                <Label htmlFor="email-cta" className="sr-only">Email</Label>
                <Input
                  id="email-cta"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  className="h-12"
                />
              </div>
              <Button 
                type="submit" 
                size="lg"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Subscribing..." : "Get Early Access"}
              </Button>
            </form>
          ) : (
            <div className="flex items-center justify-center gap-2 bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-300 p-3 rounded-md max-w-md mx-auto">
              <Check className="h-5 w-5 flex-shrink-0" />
              <p>Thanks! We'll notify you when Agent V launches.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
